/* GriffinResponsiveAside.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXrunmFW%7Bbackground-color%3Avar(--ds-surface-sunken%2C%23f8f8f8)%7D%0A._0jFU0VN91d%7Bheight%3A100%25%7D%0A._46hvQmNHnM%7Bpadding-block-start%3Avar(--ds-space-300%2C24px)%7D%0A._0LQT5ENHnM%7Bpadding-inline-start%3Avar(--ds-space-300%2C24px)%7D%0A._03SyCPNHnM%7Bpadding-inline-end%3Avar(--ds-space-300%2C24px)%7D%0A%40media%20(min-width%3A90rem)%7B._17GTZbVa5s%7Bpadding-block-start%3Avar(--ds-space-400%2C2pc)%7D._2zv7VbVa5s%7Bpadding-inline-start%3Avar(--ds-space-400%2C2pc)%7D._2GdLiWVa5s%7Bpadding-inline-end%3Avar(--ds-space-400%2C2pc)%7D%7D%0A._2YmqfPNCjk%7Bborder-inline-start%3A1px%20solid%20var(--ds-border%2C%230b120e24)%7D%0A._0xmtkop0Oa%7Bpadding-block-end%3Avar(--ds-space-600%2C3pc)%7D%0A._0rIjyk2ADO%7Bmargin-block-end%3Avar(--ds-space-100%2C8px)%7D");








import React, { PropsWithChildren, useState } from 'react';
import { cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { GriffinMainGridAside, type defaultAsideWidths } from '@townsquare/griffin-main-grid/aside';
import { useOnMount } from '@townsquare/hooks';
import { ErrorBoundary } from '@townsquare/monitoring/error-boundary';
type Props = {
  hasNewHeader: boolean;
};
const compiledStyles = {
  aside: "_0KLXrunmFW",
  asideBox: "_0jFU0VN91d _46hvQmNHnM _0LQT5ENHnM _03SyCPNHnM _17GTZbVa5s _2zv7VbVa5s _2GdLiWVa5s",
  asideWithBorder: "_2YmqfPNCjk",
  asideWithRovoButton: "_0xmtkop0Oa _0rIjyk2ADO"
};

// Based on https://atlassian.design/foundations/grid-beta#side-navigation-and-aside
const getAsideWidth = (bodyWidth: number) => {
  if (bodyWidth < 1440) {
    return 320; // defaultSmall
  } else if (bodyWidth < 1768) {
    return 400; // default
  } else {
    return 504; // defaultLarge
  }
};
export const GriffinResponsiveAside = ({
  children,
  hasNewHeader
}: PropsWithChildren<Props>): React.JSX.Element => {
  const [asideWidth, setAsideWidth] = useState<defaultAsideWidths>();
  useOnMount(() => {
    const resizeObserver = new ResizeObserver(([entry]: ResizeObserverEntry[]) => {
      const {
        width
      } = entry.contentRect;
      setAsideWidth(getAsideWidth(width));
    });
    resizeObserver.observe(window.document.body);
    return () => {
      resizeObserver.unobserve(window.document.body);
    };
  });
  return <ErrorBoundary variant="aside">
			<GriffinMainGridAside defaultWidth={asideWidth} xcss={hasNewHeader ? undefined : compiledStyles.aside}>
				<Box xcss={cx(compiledStyles.asideBox, hasNewHeader ? compiledStyles.asideWithBorder : undefined, compiledStyles.asideWithRovoButton)}>
					{children}
				</Box>
			</GriffinMainGridAside>
		</ErrorBoundary>;
};